export default process.env.NODE_ENV === 'development' ? (state, action) => {
  if (!!action.error) {
    console.log(action.type, action.error);
  }
  return true;
} : () => false;



// WEBPACK FOOTER //
// ./src/reducers/consoleLogErrors.js